import { Drawer } from "antd";
import { type FC } from "react";
import "../../styles.less";
import UseAutozoneNetworkCalls from "../../utils/UseAutozoneNetworkCalls";
import DrawerData from "./DrawerData";

interface AutozonesDrawerProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  fieldId: string;
  loading?: boolean;
}

const AutozonesDrawer: FC<AutozonesDrawerProps> = ({
  visible,
  setVisible,
  fieldId,
}) => {
  const onClose = (): void => {
    setVisible(false);
  };

  UseAutozoneNetworkCalls(visible, fieldId);

  return (
    <>
      <Drawer
        title="Autozone layer"
        placement="right"
        closable={true}
        onClose={onClose}
        open={visible}
        width="380px"
        autoFocus={true}
        styles={{
          body: {
            paddingTop: 0,
          },
        }}
        getContainer={false} // fit inside parent and not page body
      >
        {<DrawerData fieldId={fieldId} onClose={onClose} />}
      </Drawer>
    </>
  );
};

export default AutozonesDrawer;
